import React from 'react';
import { Flex, Text } from 'pcln-design-system';
import { format } from 'date-fns/format';
const MessageFooter = ({
  date
}) => {
  const footerMessageDateString = date ? format(date, "LLL d 'at' h:mm:ss aaa") : format(new Date(), "LLL d 'at' h:mm:ss aaa");
  return footerMessageDateString ? React.createElement(Flex, {
    alignItems: 'center',
    justifyContent: 'space-between'
  }, React.createElement(Text, {
    color: 'text.light',
    textStyle: 'subheading6'
  }, "Penny \u00B7 ", footerMessageDateString)) : null;
};
export default MessageFooter;